// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6 2H12C13.1 2 14 2.9 14 4V11.18M10 14H4C2.9 14 2 13.1 2 12V6',
  'M3.35 13.83L7.25 9.93M10.74 8.04C10.89 8.12 11.04 8.22 11.17 8.35L14 11.18',
  'M2 2L14 14',
];
